<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Empresas</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="upload"
          class="button"
          text="Atualizar Termo de Uso"
          icon="assets/add-excel.svg"
          (fileSelected)="uploadArquivo($event)"></app-botao>
          <div class="header-buttons">
        <app-botao
          type="secundario"
          class="button"
          title="Download Termo de Uso"
          icon="assets/exportar-excel.svg"
          (click)="downloadArquivo()"></app-botao>
      </div>
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Lista de Empresas <br /></div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getEmpresas()">
            <div class="table-filters">
              <app-input
                label="Empresa"
                width="100%"
                placeholder="Pesquisar"
                name="NM_FNTS_EPSA"
                formControlName="NM_FNTS_EPSA"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Empresa"
        width="100%"
        placeholder="Pesquisar"
        name="NM_FNTS_EPSA"
        formControlName="NM_FNTS_EPSA"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
